var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAccessDenied === true)?_c('div',{class:{'md-access-denied-overlay': _vm.isAccessDenied === true}}):_vm._e(),(_vm.isAccessDenied === true)?_c('div',{staticClass:"w-full",class:{'access-denied-lock': _vm.isAccessDenied === true}},[_c('access-denied',{staticClass:"bg-white w-2/5 mx-auto",attrs:{"height":_vm.height}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }